import {
  Box,
  Flex,
  Heading,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { greyColor, mainColor } from "./MainPage";
import WhatIsWobbleSection from "./WhatIsWobbleSection";
import MyWobbleSection from "./MyWobbleSection";
import HowToUseWobble from "./HowToUseWobble";
import WobbleFeatures from "./MainImages";

const MainSection = () => {

  const bgSize = useBreakpointValue({
    base: "cover",
    md: "calc(100% + 50px)",
  }) as string;
  const bgPosition = useBreakpointValue({
    base: "center",
    md: "center",
    lg: "center",
  });

  return (
    <Box>
      <Flex
        position="relative"
        direction="column"
        align="center"
        justify="center"
        bg={greyColor}
        color="black"
        minH={{ base: "45vh", sm: "45vh", md: "85vh" }}
        clipPath="polygon(0 0, 100% 0, 100% 85%, 0 100%)"
        textAlign="center"
        px={4}
        py={{ base: 16, md: 24 }}
        bgSize="37px 37px"
      >
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          bgImage="./assets/mockups-devices.png"
          bgSize={bgSize}
          bgPosition={bgPosition}
          opacity={0.5}
          zIndex={0}
          bgRepeat="no-repeat"
        />
        <Heading
          as="h1"
          fontSize={{ base: "xl", md: "4xl" }}
          color="black"
          zIndex={1}
          textShadow="0 0 8px rgba(255,255,255,0.6)"
          bg="white"
          textColor={mainColor}
          padding={2}
          rounded={10}
        >
          Időpontfoglaló rendszer és online megjelenés
        </Heading>
        <Text
          fontSize={{ base: "md", md: "xl" }}
          mt={4}
          color={mainColor}
          zIndex={1}
          fontWeight="medium"
          textShadow="0 0 10px rgba(255,255,255,0.6)"
          bg="white"
          padding={2}
          rounded={10}
        >
          Spórolj időt az adminisztráción, és építs online jelenlétet egy egyszerűen használható platformmal.
        </Text>
      </Flex>

      <WhatIsWobbleSection
        onPrimaryCtaHref="https://app.wobble.hu"
        onSecondaryCtaHref="https://www.youtube.com/@WobbleAppHun"
      />

      {/* <MainImages /> */}

      <WobbleFeatures />

      <MyWobbleSection />

      {/* <NewFeatures /> */}

      <Box py={12} px={{ base: 4, md: 8 }}>
        <Heading as="h2" size="xl" textAlign="center" mb={6}>
          <Text as="span" color={mainColor} fontFamily="'Lato', sans-serif">
            Wobble
          </Text>
          - Online időpontfoglaló és weboldal, fejlesztő nélkül.
        </Heading>

        <HowToUseWobble />
      </Box>
    </Box>
  );
};

export default MainSection;
